export type Category = 'Health' | 'Finance' | 'Education' | 'Social' | 'Ideology' | 'Feelings';

export const categoryImgs = {
    "Health": "/img/health-w.png",
    "Finance": "/img/piggy-bank-w.png",
    "Education": "/img/brain-w.png",
    "Social": "/img/friends-w.png",
    "Ideology": "/img/light-bulb-w.png",
    "Feelings": "/img/smile-w.png"
}